import { Box, Divider, Grid, Typography } from '@material-ui/core';
import { ReactComponent as LoyaltyIcon } from 'src/common/media/Loyalty.svg';
import React from 'react';
import { styles } from './action-window-styles';
import { setNumberWithCommas } from 'src/common/helpers/text-formatting-helper';
import { ICustomerState, Program } from 'src/common/interfaces/states/ICustomerState';
import Pagination from 'src/pagination/pagination';
import { store } from 'src/common/redux/configure-store';
import useScrollButtonState from '@ncr-retail/hooks/build/useScrollButtonState/useScrollButtonState';
import { TFunction, useTranslation } from 'react-i18next';
import { themeColor } from 'src/mui-theme';
import { LoyaltyProgram } from 'src/common/enumerations/customer-loyalty';

const CustomerLoyaltyData: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const zoomLevel = store.getState().cashierPreferences.textZoomLevel;
  const classes = styles({});
  const { customer } = props;
  let points = 0;
  // Filter out MSV from display as a loyalty program.  Calcuate points based on valid programs that are displayed.
  const programData = customer?.programBalances?.filter(program => {
    if (program.programType !== LoyaltyProgram.StoredValue) {
      if (program && program.earnedPoints) {
        points += program.earnedPoints;
      }
      return true;
    }
    return false;
  });
  const [{ currentPage, lastPage, onPageChanged }, scrollRef] = useScrollButtonState(
    programData?.length,
  );

  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
      justifyContent='flex-start'
      className={`fullHeight ${classes.loyaltyCustomerAndCardWrapper}`}
      alignItems='stretch'
    >
      <Grid
        container
        item
        direction='row'
        alignItems='center'
        className={classes.loyaltyCustomerLine}
      >
        <LoyaltyIcon fill={themeColor.secondaryMain} data-testid='loyalty-customer-card-icon' />
        <Typography
          className={classes.loyaltyCustomerName}
          data-testid='loyalty-customer-name-text'
        >
          {t('CustomerView_Loyalty_program_name')}
        </Typography>
      </Grid>
      <Grid
        container
        direction='column'
        wrap='nowrap'
        ref={scrollRef}
        className={`verticalScroll ${classes.scrollWrapper}`}
      >
        <Box data-testid='loyalty-card-scroll-window'>
          {programData?.map(
            (program: Partial<Program>): JSX.Element => {
              return (
                <ProgramDetailLine
                  zoomLevel={zoomLevel}
                  program={program}
                  translator={t}
                  key={program.programId}
                />
              );
            },
          )}
        </Box>
      </Grid>
      {customer && (
        <>
          <Grid
            container
            item
            direction='row'
            justifyContent='flex-end'
            alignItems='center'
            className={classes.loyaltyTotalPointsLine}
          >
            <span>{t('FooterPanelView_Points')}:</span>
            <span
              className={`${classes.loyaltyTotalPoints}`}
              data-testid='loyalty-customer-points-text'
            >
              {setNumberWithCommas(points)}
            </span>
          </Grid>
          <Divider />
        </>
      )}
      <Grid container item justifyContent='center'>
        <Pagination
          currentPage={currentPage}
          totalPages={lastPage}
          updateCurrentPageHandler={onPageChanged}
          testIdPrefix={'customer-loyalty'}
        />
      </Grid>
    </Grid>
  );
};

interface Props {
  customer: Partial<ICustomerState> | undefined;
}

const ProgramDetailLine: React.FC<ProgramProps> = (props: ProgramProps): JSX.Element => {
  const classes = styles({});
  return (
    <Grid container className={`${classes.indCardHolder} ${classes.indentedLine}`}>
      <span>{props.program?.programId}</span>
      <span>{`${props.program?.earnedPoints} ${props.translator('FooterPanelView_Points')}`}</span>
    </Grid>
  );
};
interface ProgramProps {
  program: Partial<Program> | undefined;
  zoomLevel: number;
  translator: TFunction;
}

export default CustomerLoyaltyData;
